import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import { Box } from '@mui/material';
import GirviPageShell from '../../common/GirviPageShell';
import PreAuctionCatalogue from './PreAuctionCatalogue';
import AuctionEntryTab from './AuctionEntryTab';
import AuctionListTab from './AuctionListTab';
import AuctionReserveTab from './AuctionReserveTab';
import SaleIntimationLetterTab from './SaleIntimationLetterTab';
import ReminderLetterTab from './ReminderLetterTab';

const AuctionPage = () => {
  const location = useLocation();
  const path = location.pathname;

  const renderSection = () => {
    if (path.includes('/auction/catalogue')) return <PreAuctionCatalogue />;
    if (path.includes('/auction/entry')) return <AuctionEntryTab />;
    if (path.includes('/auction/list')) return <AuctionListTab />;
    if (path.includes('/auction/reserve')) return <AuctionReserveTab />;
    if (path.includes('/auction/sale-intimation')) return <SaleIntimationLetterTab />;
    if (path.includes('/auction/reminder')) return <ReminderLetterTab />;
    return null;
  };

  if (path === '/auction' || path === '/auction/') {
    return <Navigate to="/auction/catalogue" replace />;
  }

  const sectionTitle = () => {
    if (path.includes('/auction/catalogue')) return 'Pre-Auction Catalogue';
    if (path.includes('/auction/entry')) return 'Auction Entry';
    if (path.includes('/auction/list')) return 'Auction List';
    if (path.includes('/auction/reserve')) return 'Auction Reserve';
    if (path.includes('/auction/sale-intimation')) return 'Sale Intimation Letter';
    if (path.includes('/auction/reminder')) return 'Reminder Letter';
    return 'Auction';
  };

  return (
    <GirviPageShell
      title={sectionTitle()}
      subtitle="Auction · Workflow"
      chipLabel="Auction"
      maxWidth="xl"
    >
      <Box sx={{ pt: 1 }}>{renderSection()}</Box>
    </GirviPageShell>
  );
};

export default AuctionPage;
